import { AxiosRequestConfig, AxiosResponse } from "axios";
import { getAxiosInstances } from "../../../../utils/AppUtils";
import { CLIENT_ID, OAUTH_BASE_URL } from "../../../app.config";
import AxiosActions from "../../AxiosActions";
import { objectToEncodedRequestBody } from "../../../../utils/AuthUtils/AuthUtils";

export const getContextAuthorizationCode = (config: AxiosRequestConfig = {}, spinner = true) => {
    return AxiosActions.get(getAxiosInstances().V2, "/organization/auth-code", config, spinner);
};
export const getOauth2Authorize = (queryParams: object) => {
    let params = "?";
    Object.keys(queryParams).forEach((key: string, index: number) => {
        params += `${index > 0 ? "&" : ""}${key}=${queryParams[key]}`;
    });

    window.location.href = `${OAUTH_BASE_URL}auth/oauth2/authorize${params}`;
};
export const enableMFA = (): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/mfa/enable`, null, {}, true);
};

export const disableMFA = (): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/mfa/disable`, null, {}, true);
};

export const validateAndEnableTotp = (code: string, config?: any): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/mfa/validate?code=${code}`, null, { ...config }, true);
};

export const enableTotp = (): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/mfa/enable/totp`, null, {}, true);
};

export const disableTotp = (): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/mfa/disable/totp`, null, {}, true);
};
export const getContactPoints = (config: any): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `mfa/config`, { withCredentials: false, ...config }, true);
};

export const sendCodeUsingContactPoint = (config: any): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `mfa/send-code`, null, { withCredentials: false, ...config }, true);
};
// Accepts the refresh token explicitly so callers can refresh a specific tenant's
// access token (NG-8052) — no switch-tenant call is needed on refresh. CAVEAT: the BE
// pins the tenant only on switch-minted sessions; refreshing a login-minted session
// stamps the user's PERSISTED tenant context, which can name a different tenant. Callers
// must verify the returned token's tenantId claim before storing it (see
// storeRefreshedTokens and the useTenantSwitching claim guard).
export const refreshAccessToken = async (refreshToken: string): Promise<AxiosResponse> => {
    // curl --location --request POST 'https://test.1hdev.io/auth/oauth2/token' \
    //         --header 'Content-Type: application/x-www-form-urlencoded' \
    //         --data-urlencode 'grant_type=refresh_token' \
    //         --data-urlencode 'refresh_token=9p20TitPn2NOHB_GE3u8VKO2Yr18PbrL87XE6DFOaz_gGQ5nEYCc_VGVA4hlCmkKDNFKrQvLovG7mPmc5CCJtByUCbRAkiv3Kb38kG86Eu-ORsUcnvT2k9RKOOmgFZPF' \
    //         --data-urlencode 'client_id=public-client'

    //         leaving data here since we do not have a swagger for this api

    const details = {
        grant_type: "refresh_token",
        refresh_token: refreshToken,
        client_id: `${CLIENT_ID}`,
    };

    return AxiosActions.post(
        getAxiosInstances().AUTH,
        "oauth2/token",
        objectToEncodedRequestBody(details),
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        false,
    );
};

export const getOauth2Token = (data, config): Promise<AxiosResponse> => {
    return AxiosActions.post(
        getAxiosInstances().AUTH,
        "oauth2/token",
        objectToEncodedRequestBody(data),
        {
            ...config,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        false,
        undefined,
        true,
    );
};
export const forgotPassword = (dto: any): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/public/reset-password`, dto, { withCredentials: false }, true);
};
